import { ClockCircleOutlined } from '@ant-design/icons';
import { Popover, Typography } from 'antd';
import React from 'react';
import styled from 'styled-components/macro';
import { toLocalDateTimeString, toRelativeTimeString } from '../../../../../shared/time/timeUtils';
import { useTranslation } from '../../../../../../i18n/useTranslation';
import { ANTD_GRAY } from '../../../../shared/constants';

const CurrentVersionTimestampText = styled(Typography.Text)`
    &&& {
        line-height: 22px;
        margin-top: 10px;
        margin-right: 10px;
        color: ${ANTD_GRAY[7]};
        width: max-content;
    }
`;

const TimeStampWrapper = styled.div`
    margin-bottom: 5px;
`;

const StyledClockIcon = styled(ClockCircleOutlined)`
    margin-right: 5px;
`;

interface Props {
    lastUpdated?: number | null;
    lastObserved?: number | null;
}

function SchemaTimeStamps(props: Props) {
    const { t } = useTranslation();
    const { lastUpdated, lastObserved } = props;
    if (!lastUpdated && !lastObserved) return null;

    return (
        <Popover
            content={
                <>
                    {!!lastObserved && (
                        <TimeStampWrapper>
                            {t('Last observed on {{date}}', { date: toLocalDateTimeString(lastObserved) })}
                        </TimeStampWrapper>
                    )}
                    {!!lastUpdated && (
                        <div>{t('First reported on {{date}}', { date: toLocalDateTimeString(lastUpdated) })}.</div>
                    )}
                </>
            }
        >
            <CurrentVersionTimestampText>
                {!!lastObserved && (
                    <span>
                        <StyledClockIcon />{' '}
                        {t('Last observed on {{date}}', { date: toRelativeTimeString(lastObserved) })}
                    </span>
                )}
                {!lastObserved && !!lastUpdated && (
                    <span>
                        <StyledClockIcon />
                        {t('First reported on {{date}}', { date: toRelativeTimeString(lastUpdated) })}
                    </span>
                )}
            </CurrentVersionTimestampText>
        </Popover>
    );
}

export default SchemaTimeStamps;
